<template>
  <header class="zui-header">
    <slot></slot>
  </header>
</template>
<script>
  import '../../assets/less/header.less'
  export default {
    props: {
      logoType: {
        default: 'zhichou'
      }
    },
    components: {}
  }
</script>
